import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const OfflineAdvantages = () => {
  const advantages = [
  {
    id: 1,
    icon: "Wifi",
    title: "True Offline Operation",
    description: "Run your store completely offline. Cultaz Desktop supports Server and Client modes - a local server for multi-terminal setups or single-terminal client mode that connects to a remote server.",
    image: "/desktop-app-screenshots/UI1.png",
    imageAlt: "Cultaz Desktop POS interface showing offline operation"
  },
  {
    id: 2,
    icon: "Zap",
    title: "Lightning-Fast Performance",
    description: "Experience instant response times with local processing. No lag, no loading delays, no waiting for cloud servers to respond to your requests.",
    image: "/desktop-app-screenshots/startup-page.png",
    imageAlt: "Cultaz Desktop startup page showing fast loading"
  },
  {
    id: 3,
    icon: "Database",
    title: "Complete Data Control",
    description: "Your business data stays on your premises. Full ownership and control over customer information, sales records, and inventory data with local backups.",
    image: "/desktop-app-screenshots/settings-page.png",
    imageAlt: "Cultaz Desktop settings showing data control options"
  },
  {
    id: 4,
    icon: "DollarSign",
    title: "Cost-Effective Ownership",
    description: "Monthly desktop licensing provides predictable billing and flexible payment options. Optional maintenance or renewals enable updates and advanced features - core POS stays available even if a plan changes.",
    image: "/desktop-app-screenshots/UI1.png",
    imageAlt: "Cultaz Desktop POS showing cost-effective licensing options"
  },
  {
    id: 5,
    icon: "Lock",
    title: "Enhanced Security",
    description: "Sensitive data is stored locally (SQLite) and encrypted. Licenses and backups use strong encryption (AES-256) and licenses are machine-bound to prevent unauthorized sharing.",
    image: "/desktop-app-screenshots/settings-page.png",
    imageAlt: "Cultaz Desktop security settings showing encryption options"
  },
  {
    id: 6,
    icon: "TrendingUp",
    title: "Predictable Performance",
    description: "Consistent system performance regardless of network conditions. No slowdowns during peak hours or bandwidth limitations affecting your operations.",
    image: "/desktop-app-screenshots/UI1.png",
    imageAlt: "Cultaz Desktop POS showing consistent performance metrics"
  }];


  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
            Why Choose Offline Desktop POS?
          </h2>
          <p className="font-body text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            Experience the reliability and control that comes with local software. Your business operations remain unaffected by external factors.
          </p>
        </div>

        <div className="space-y-12 md:space-y-16 lg:space-y-20">
          {advantages?.map((advantage, index) =>
          <div
            key={advantage?.id}
            className={`flex flex-col ${
            index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 md:gap-10 lg:gap-12 items-center`
            }>

              <div className="w-full lg:w-1/2">
                <div className="relative overflow-hidden rounded-2xl shadow-purple-lg transition-smooth hover:shadow-purple-xl">
                  <div className="aspect-[4/3]">
                    <Image
                    src={advantage?.image}
                    alt={advantage?.imageAlt}
                    className="w-full h-full object-cover" />

                  </div>
                </div>
              </div>

              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-4 md:mb-6">
                  <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-primary/10 rounded-xl">
                    <Icon name={advantage?.icon} size={28} color="var(--color-primary)" strokeWidth={2} />
                  </div>
                  <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
                    {advantage?.title}
                  </h3>
                </div>
                <p className="font-body text-base md:text-lg text-muted-foreground leading-relaxed">
                  {advantage?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default OfflineAdvantages;